<template>
  <div class='wrapper-page'>
    <modal ref='tagForm'>
      <template #header>
        <h5 class='modal-title mt-0'>{{$t('tag.edit')}}</h5>
      </template>

      <template #body>
        <form @submit.prevent='updateTag($event)'>
          <div class='modal-body'>
            <div class='form-group'>
              <label class='col-form-label'>
                {{$t('tag.name')}}
              </label>

              <input required='required' type='text' name='tag[name]' class='form-control' :value='modalTag.name'>
            </div>

            <div class='form-group'>
              <tag-color-picker :startingColor='modalTag.color' />
            </div>
          </div>
          <div class='modal-footer'>
            <input type='submit' name='commit' :value="$t('tag.save')" class='btn btn-primary'>
          </div>
        </form>
      </template>
    </modal>

    <modal ref='tagProductModal'>
      <template #header>
        <h5 class="modal-title mt-0">{{$t('tags.show.add_element', {name: userProductTitle})}}</h5>
      </template>

      <template #body>
        <form @submit.prevent="attachProduct">
          <div class="modal-body">
            <div class="form-group">
              <multi-select :getter="getProducts" v-model='selectedProducts' />
            </div>
          </div>

          <div class="modal-footer">
            <input type="submit" name="commit" :value="$t('tag.add')" class="btn btn-primary float-right">
          </div>
        </form>
      </template>
    </modal>

    <modal ref='tagDocumentTypeModal'>
      <template #header>
        <h5 class="modal-title mt-0">{{$t('tags.show.add_element', {name: userDocumentTypeTitle})}}</h5>
      </template>

      <template #body>
        <form @submit.prevent="attachDocumentType">
          <div class="modal-body">
            <div class="form-group">
              <multi-select :getter="getDocumentTypes" v-model='selectedDocumentTypes' />
            </div>
          </div>

          <div class="modal-footer">
            <input type="submit" name="commit" :value="$t('tag.add')" class="btn btn-primary float-right">
          </div>
        </form>
      </template>
    </modal>

    <modal ref='tagContactModal'>
      <template #header>
        <h5 class="modal-title mt-0">{{$t('tag.add_contact')}}</h5>
      </template>

      <template #body>
        <form @submit.prevent="attachContact">
          <div class="modal-body">
            <div class="form-group">
              <multi-select :getter="getContacts" v-model='selectedContacts' :template='contactTemplate' />
            </div>
          </div>

          <div class="modal-footer">
            <input type="submit" name="commit" :value="$t('tag.add')" class="btn btn-primary float-right">
          </div>
        </form>
      </template>
    </modal>

    <modal ref='tagFolderModal'>
      <template #header>
        <h5 class="modal-title mt-0">{{$t('tag.add_folder')}}</h5>
      </template>

      <template #body>
        <form @submit.prevent="attachFolder">
          <div class="modal-body">
            <div class="form-group">
              <multi-select :template='folderTemplate' :getter="getFolders" v-model='selectedFolders' />
            </div>
          </div>

          <div class="modal-footer">
            <input type="submit" name="commit" :value="$t('tag.add')" class="btn btn-primary float-right">
          </div>
        </form>
      </template>
    </modal>

    <div class='container-fluid'>
      <h1 class='page-title'>
        {{$t('tags.show.header', {tagName: tag.name})}}
        <div :class="['tag-small-circle', tag.color]"></div>
        <a @click.prevent='openModal($refs.tagForm)' href='#' class='edit'>
          {{$t('tags.show.edit')}}
        </a>
      </h1>
      <div class='dropdown float-right add-to-tags m-t-60'>
        <button data-toggle='dropdown' type='button' class='btn dropdown-toggle btn-outline-primary'>
          {{$t('tags.show.add')}}
        </button>

        <div class='dropdown-menu dropdown-menu-right'>
          <ul>
            <li>
              <a href='#' @click.prevent='openDocumentTypeModal($refs.tagDocumentTypeModal)'>
                <img src='../assets/document-types-brown.svg' />
                {{$t('tags.show.add_element', {name: userDocumentTypeTitle})}}
              </a>
            </li>
            <li>
              <a href='#' @click.prevent='openProductModal($refs.tagProductModal)'>
                <img src='../assets/products-brown.svg' />
                {{$t('tags.show.add_element', {name: userProductTitle})}}
              </a>
            </li>
            <li>
              <a href='#'  @click.prevent='openContactModal($refs.tagContactModal)'>
                <img src='../assets/contact-brown.svg' />
                {{$t('tags.show.add_contacts')}}
              </a>
            </li>
            <li>
              <a href='#'  @click.prevent='openFolderModal($refs.tagFolderModal)'>
                <img src="../assets/folders-brown.svg">
                {{$t('tags.show.add_folder')}}
              </a>
            </li>
          </ul>
        </div>
      </div>
      <div class="clearfix"></div>

      <div v-if='visibleTags' class='empty-list-wrapper'>
        <img src='../assets/empty_states/tags.png'>
        <p>{{$t('tags.show.tag_no')}}</p>
      </div>
      <div class="has-tags-list" v-else>
        <div class='nav-tabs-wrapper'>
          <ul role='tablist' class='nav nav-tabs'>
            <li class='nav-item'>
              <a href='#contacts' :class="['nav-link', { active: activeTab == 'contacts' }]">
                {{$t('tags.show.contact_len', {contactsLength: tagContacts.length})}}
              </a>
            </li>
            <li class='nav-item'>
              <a href='#files' :class="['nav-link', { active: activeTab == 'files' }]">
                {{$t('tags.show.files_len', {tagRecords: tagRecords.length})}}
              </a>
            </li>
            <li class='nav-item'>
              <a href='#products' :class="['nav-link', { active: activeTab == 'products' }]">
                {{ userProductTitle }} ({{ activeProducts.length }})
              </a>
            </li>
            <li class='nav-item'>
              <a href='#archived_products' :class="['nav-link', { active: activeTab == 'archived_products' }]">
                {{$t('tags.show.archived', {name: userProductTitle})}} ({{ archivedProducts.length }})
              </a>
            </li>
            <li class='nav-item'>
              <a href='#document-types' :class="['nav-link', { active: activeTab == 'document-types' }]">
                {{ userDocumentTypeTitle }} ({{ activeDocumentTypes.length }})
              </a>
            </li>
            <li class='nav-item'>
              <a href='#archived-document-types' :class="['nav-link', { active: activeTab == 'archived-document-types' }]">
                {{$t('tags.show.archived', {name: userDocumentTypeTitle})}} ({{ archivedDocumentTypes.length }})
              </a>
            </li>
            <li class='nav-item'>
              <a href='#messages' :class="['nav-link', { active: activeTab == 'messages' }]">
                {{$t('tags.show.messages', { messages: messages.length})}}
              </a>
            </li>
            <li class='nav-item'>
              <a href='#folders' :class="['nav-link', { active: activeTab == 'folders' }]">
                Folders ({{ tagFolders.length }})
              </a>
            </li>
          </ul>
        </div>

        <div class='tab-content'>
          <div :class="['tab-pane', { active: activeTab == 'contacts' }]">
            <loading v-if="loading" />
            <div v-else-if="tagContacts.length === 0 && !loading" class='empty-list-wrapper'>
              <img src='../assets/empty_states/tags.png'>
              <p>{{$t('tags.show.tag_no_contact')}}</p>
            </div>
            <table class='table' v-else>
              <thead>
                <tr>
                  <th>{{$t('tags.show.tag_contact_name')}}</th>
                  <th>{{$t('tags.show.tag_contact_email')}}</th>
                  <th>{{$t('tags.show.tags')}}</th>
                </tr>
              </thead>

              <tbody name="fade" is="transition-group">
                <tr v-for='contact in tagContacts' :key='contact.id'>
                  <td>
                    <router-link :to="{name: 'contact_folders', params: { id: contact.id }}">
                      {{contact.name}}
                    </router-link>
                  </td>

                  <td>
                    <router-link :to="{name: 'contact_folders', params: { id: contact.id }}">
                      {{contact.email}}
                    </router-link>

                  </td>

                  <td class='tag-dropdown-column'>
                    <div :class="['existing-tags-wrapper', tag.color]" v-for='tag in contact.tags' :key='tag.id'>
                      <div class='btn-group btn-group-toggle'>
                        <label class='btn active'>
                          <router-link :to="{name: 'tag', params: { id: tag.id }}">
                            {{tag.name}}
                          </router-link>
                        </label>

                        <label class='btn' @click.prevent='removeConnectedTag(tag, { contact_id: contact.id })'>
                          <i class='fa fa-remove'></i>
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div :class="['tab-pane', { active: activeTab == 'files' }]">
            <loading v-if="loading" />
            <div v-else-if="tagRecords.length === 0 && !loading" class='empty-list-wrapper'>
              <img src='../assets/empty_states/tags.png'>
              <p>{{$t('tags.show.tag_no_files')}}</p>
            </div>
            <table class='table' v-else>
              <thead>
                <tr>
                  <th>{{$t('tags.show.tag_file_name')}}</th>
                  <th>{{$t('tags.show.tags')}}</th>
                </tr>
              </thead>

              <tbody name="fade" is="transition-group">
                <tr v-for='record in tagRecords' :key='record.id'>
                  <td>
                    <router-link :to="{name: 'record', params: { id: record.id }}">
                      {{record.filename}}
                    </router-link>
                  </td>

                  <td class='tag-dropdown-column'>
                    <div :class="['existing-tags-wrapper', tag.color]" v-for='tag in record.tags' :key='tag.id'>
                      <div class='btn-group btn-group-toggle'>
                        <label class='btn active'>
                          <router-link :to="{name: 'tag', params: { id: tag.id }}">
                            {{tag.name}}
                          </router-link>
                        </label>

                        <label class='btn' @click.prevent='removeConnectedTag(tag, { record_id: record.id })'>
                          <i class='fa fa-remove'></i>
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div :class="['tab-pane', { active: activeTab == 'products' }]">
            <loading v-if="loading" />
            <div class='empty-list-wrapper' v-else-if="tagProducts.length === 0 && !loading">
              <img src='../assets/empty_states/tags.png'>
              <p>{{$t('tags.show.tag_no_product')}}</p>
            </div>
            <table class='table' v-else>
              <thead>
                <tr>
                  <th>{{userProductName}}</th>
                  <th>{{userProductCode}}</th>
                  <th>{{$t('tags.show.tags')}}</th>
                </tr>
              </thead>

              <tbody name="fade" is="transition-group">
                <tr v-for='product in activeProducts' :key='product.id'>
                  <td>
                    <router-link :to="{name: 'product', params: { id: product.id }}">
                      {{product.name}}
                    </router-link>
                  </td>

                  <td>
                    <router-link :to="{name: 'product', params: { id: product.id }}">
                      {{product.code}}
                    </router-link>
                  </td>

                  <td class='tag-dropdown-column'>
                    <div :class="['existing-tags-wrapper', tag.color]" v-for='tag in product.tags' :key='tag.id'>
                      <div class='btn-group btn-group-toggle'>
                        <label class='btn active'>
                          <router-link :to="{name: 'tag', params: { id: tag.id }}">
                            {{tag.name}}
                          </router-link>
                        </label>

                        <label class='btn' @click.prevent='removeConnectedTag(tag, { product_id: product.id })'>
                          <i class='fa fa-remove'></i>
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div :class="['tab-pane', { active: activeTab == 'archived_products' }]">
            <loading v-if="loading" />
            <div class='empty-list-wrapper' v-else-if="archivedProducts.length === 0 && !loading">
              <img src='../assets/empty_states/tags.png'>
              <p>{{$t('tags.show.tag_no_archived_product')}}</p>
            </div>
            <table class='table' v-else>
              <thead>
                <tr>
                  <th>{{userProductName}}</th>
                  <th>{{userProductCode}}</th>
                  <th>{{$t('tags.show.tags')}}</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for='product in archivedProducts' :key='product.id'>
                  <td>
                    <router-link :to="{name: 'product', params: { id: product.id }}">
                      {{product.name}}
                    </router-link>
                  </td>

                  <td>
                    <router-link :to="{name: 'product', params: { id: product.id }}">
                      {{product.code}}
                    </router-link>
                  </td>

                  <td class='tag-dropdown-column'>
                    <div :class="['existing-tags-wrapper', tag.color]" v-for='tag in product.tags' :key='tag.id'>
                      <div class='btn-group btn-group-toggle'>
                        <label class='btn active'>
                          <router-link :to="{name: 'tag', params: { id: tag.id }}">
                            {{tag.name}}
                          </router-link>
                        </label>

                        <label class='btn' @click.prevent='removeConnectedTag(tag, { product_id: product.id })'>
                          <i class='fa fa-remove'></i>
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div :class="['tab-pane', { active: activeTab == 'document-types' }]">
            <loading v-if="loading" />
            <div class='empty-list-wrapper' v-else-if="activeDocumentTypes.length === 0 && !loading">
              <img src='../assets/empty_states/tags.png'>
              <p>{{$t('tags.show.tag_no_archived_dt')}}</p>
            </div>
            <table class='table' v-else>
              <thead>
                <tr>
                  <th>{{ userDocumentTypeName }}</th>
                  <th>{{$t('tags.show.tags')}}</th>
                </tr>
              </thead>

              <tbody name="fade" is="transition-group">
                <tr v-for='documentType in activeDocumentTypes' :key='documentType.id'>
                  <td>
                    <router-link :to="{name: 'document_type', params: { id: documentType.id }}">
                      {{documentType.name}}
                    </router-link>
                  </td>

                  <td class='tag-dropdown-column'>
                    <div :class="['existing-tags-wrapper', tag.color]" v-for='tag in documentType.tags' :key='tag.id'>
                      <div class='btn-group btn-group-toggle'>
                        <label class='btn active'>
                          <router-link :to="{name: 'tag', params: { id: tag.id }}">
                            {{tag.name}}
                          </router-link>
                        </label>

                        <label class='btn' @click.prevent='removeConnectedTag(tag, { document_type_id: documentType.id })'>
                          <i class='fa fa-remove'></i>
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div :class="['tab-pane', { active: activeTab == 'archived-document-types' }]">
            <loading v-if="loading" />
            <div class='empty-list-wrapper' v-else-if="archivedDocumentTypes.length === 0 && !loading">
              <img src='../assets/empty_states/tags.png'>
              <p>{{$t('tags.show.tag_no_product')}}</p>
            </div>
            <table class='table' v-else>
              <thead>
                <tr>
                  <th>{{ userDocumentTypeName }}</th>
                  <th>{{$t('tags.show.tags')}}</th>
                </tr>
              </thead>

              <tbody name="fade" is="transition-group">
                <tr v-for='documentType in archivedDocumentTypes' :key='documentType.id'>
                  <td>
                    <router-link :to="{name: 'document_type', params: { id: documentType.id }}">
                      {{documentType.name}}
                    </router-link>
                  </td>

                  <td class='tag-dropdown-column'>
                    <div :class="['existing-tags-wrapper', tag.color]" v-for='tag in documentType.tags' :key='tag.id'>
                      <div class='btn-group btn-group-toggle'>
                        <label class='btn active'>
                          <router-link :to="{name: 'tag', params: { id: tag.id }}">
                            {{tag.name}}
                          </router-link>
                        </label>

                        <label class='btn' @click.prevent='removeConnectedTag(tag, { document_type_id: documentType.id })'>
                          <i class='fa fa-remove'></i>
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div :class="['tab-pane', { active: activeTab == 'messages' }]">
            <loading v-if="loading" />
            <div class='empty-list-wrapper' v-else-if="messages.length === 0 && !loading">
              <img src='../assets/empty_states/tags.png'>
              <p>{{$t('tags.show.tag_no_archived_dt')}}</p>
            </div>
            <table class='table' v-else>
              <thead>
              <tr>
                <th>{{ $t('communication.message_type')}}</th>
                <th>{{ $t('communication.contact_name')}}</th>
                <th>{{ $t('communication.subject')}}</th>
                <th>{{ $t('communication.date')}}</th>
                <th>{{ $t('tags.show.tags')}}</th>
              </tr>
              </thead>

              <tbody name="fade" is="transition-group">
                <tr v-for='message in messages' :key='message.id'>
                  <td class="data-img">
                    <span v-if="message.type === 'DocumentRequest'"
                          :data-tooltip="$t('communication.tooltip.sent_message')" class="own-tooltip own-tooltip-bottom">
                        <img src="../assets/search/sent-mail.svg" />
                    </span>
                    <span v-if="message.type === 'DocumentResponse'"
                          :data-tooltip="$t('communication.tooltip.received_message')" class="own-tooltip own-tooltip-bottom">
                        <img src="../assets/search/incoming-mail.svg" />
                    </span>
                    <span v-if="message.type === 'SentEmail'"
                          :data-tooltip="$t('communication.tooltip.automated_email')" class="own-tooltip own-tooltip-bottom">
                        <img src="../assets/search/message.svg" />
                    </span>
                    <span v-if="message.type === 'RecordMessage'"
                          :data-tooltip="$t('communication.tooltip.file_communication')" class="own-tooltip own-tooltip-bottom">
                        <img src="../assets/search/internal_message.svg" />
                    </span>
                  </td>
                  <td>

                    <router-link v-if="message.type === 'RecordMessage'"
                                 :to="{name: 'record_message_show', params: { id: message.id, referrer: $route.name }, query: { type: 'tag-messages', type_id: tag.id }}">
                        {{ sentTo(message) }}
                    </router-link>
                    <router-link v-else :to="{name: 'message', params: { id: message.id, referrer: $route.name, messageType: routeMessageType(message) }}">
                      {{ message.contact_name }}
                      <span v-if="message.contact_name && message.contact_email"> - </span>
                      {{ message.contact_email }}
                    </router-link>
                  </td>
                  <td>
                    <router-link :to="{name: 'message', params: { id: message.id, referrer: $route.name, messageType: routeMessageType(message) }}">
                      <span v-if="message.subject">{{ message.subject }}</span>
                      <span v-else>{{ $t('communication.no_subject')}}</span>
                    </router-link>
                  </td>
                  <td>{{formatDate(message.created_at)}}</td>
                  <td class='tag-dropdown-column'>
                    <div :class="['existing-tags-wrapper', tag.color]" v-for='tag in message.tags' :key='tag.id'>
                      <div class='btn-group btn-group-toggle'>
                        <label class='btn active'>
                          <router-link :to="{name: 'tag', params: { id: tag.id }}">
                            {{tag.name}}
                          </router-link>
                        </label>
                        <label class='btn' v-if="message.type === 'DocumentRequest'" @click.prevent='removeConnectedTag(tag, { document_request_id: message.id })'>
                          <i class='fa fa-remove'></i>
                        </label>
                        <label class='btn' v-else-if="message.type === 'DocumentResponse'" @click.prevent='removeConnectedTag(tag, { document_response_id: message.id })'>
                          <i class='fa fa-remove'></i>
                        </label>
                        <label class='btn' v-else-if="message.type === 'SentEmail'" @click.prevent='removeConnectedTag(tag, { sent_email_id: message.id })'>
                          <i class='fa fa-remove'></i>
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div :class="['tab-pane', { active: activeTab == 'folders' }]">
            <loading v-if="loading" />
            <div class='empty-list-wrapper' v-if="tagFolders.length === 0 && !loading">
              <img src='../assets/empty_states/tags.png'>
              <p>{{$t('tags.show.tag_no_contact')}}</p>
            </div>
            <table class='table' v-else>
              <thead>
                <tr>
                  <th>{{ $t('folders.list.folder_name') }}</th>
                </tr>
              </thead>

              <tbody name="fade" is="transition-group">
                <tr v-for='folder in tagFolders' :key='folder.id'>
                  <td>
                    <router-link :to="{name: 'folder', params: { id: folder.id }}">
                      {{ folder.name }}
                    </router-link>
                  </td>

                  <td class='tag-dropdown-column'>
                    <div :class="['existing-tags-wrapper', tag.color]" v-for='tag in folder.tags' :key='tag.id'>
                      <div class='btn-group btn-group-toggle'>
                        <label class='btn active'>
                          <router-link :to="{name: 'tag', params: { id: tag.id }}">
                            {{tag.name}}
                          </router-link>
                        </label>
                        <label class='btn' @click.prevent='removeConnectedTag(tag, { folder_id: folder.id })'>
                          <i class='fa fa-remove'></i>
                        </label>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import _modal from '../components/_modal'
  import _loading from '../components/_loading'
  import _tag_color_picker from '../components/tags/_tag_color_picker'
  import _multi_select from '../components/shared/_infinite_multi_select'

  export default {
    components: {
      modal: _modal,
      loading: _loading,
      'multi-select': _multi_select,
      'tag-color-picker': _tag_color_picker,
    },
    watch: {
      tagId() {
        this.fetchData()
      },
    },
    created() {
      this.fetchData()
      this.store.sendMetrics({name: 'tag', params: this.$route.params, path: this.$route.fullPath})
    },
    data() {
      return {
        modalTag: {},
        selectedContacts: [],
        selectedDocumentTypes: [],
        selectedProducts: [],
        selectedFolders: [],
        loading: true
      }
    },
    computed: {
      activeTab() {
        return this.$route.hash ? this.$route.hash.substring(1) : 'contacts'
      },
      tagId() {
        return this.$route.params.id
      },
      tag() {
        return this.state.tag || {}
      },
      tagContacts() {
        return this.tag.contacts || []
      },
      tagFolders() {
        return this.tag.folders || []
      },
      tagProducts() {
        return this.tag.products || []
      },
      tagDocumentTypes() {
        return this.tag.document_types || []
      },
      activeProducts() {
        return this.tagProducts.filter(p => !p.archive)
      },
      archivedProducts() {
        return this.tagProducts.filter(p => p.archive)
      },
      activeDocumentTypes() {
        return this.tagDocumentTypes.filter(d => !d.archive)
      },
      archivedDocumentTypes() {
        return this.tagDocumentTypes.filter(d => d.archive)
      },
      tagRecords() {
        return this.tag.records || []
      },
      messages() {
        return this.tag.messages || []
      },
      visibleTags() {
        return this.activeProducts.length == 0 && this.archivedDocumentTypes.length == 0 && this.activeDocumentTypes.length == 0 && this.archivedProducts.length == 0 && this.tagRecords.length == 0 && this.tagContacts.length == 0 && this.tagFolders.length == 0 && this.messages.length == 0
      }
    },
    methods: {
      fetchData() {
        this.loading = true
        this.store.getTag(this.tagId).then(() => {
          this.loading = false
        })
      },
      openModal(modal) {
        this.modalTag = Object.assign({}, this.tag)
        modal.open()
      },
      openProductModal(modal) {
        this.modalTag = Object.assign({}, this.tag)
        modal.open()
      },
      openDocumentTypeModal(modal) {
        this.modalTag = Object.assign({}, this.tag)
        modal.open()
      },
      openContactModal(modal) {
        this.modalTag = Object.assign({}, this.tag)
        modal.open()
      },
      openFolderModal(modal) {
        this.modalTag = Object.assign({}, this.tag)
        modal.open()
      },
      updateTag(event) {
        this.store.updateTag(this.tag.id, new FormData(event.target)).then(() => {
          this.store.sendMetrics({name: 'update_tag', params: this.$route.params, path: this.$route.fullPath})
          this.store.getTag(this.tagId)
          this.$refs.tagForm.close()
        })
      },
      removeConnectedTag(tag, params) {
        this.store.removeConnectedTag(tag.id, params).then(() => {
          this.store.sendMetrics({name: 'remove_connected_tag', params: this.$route.params, path: this.$route.fullPath})
          this.store.getTag(this.tagId)
        })
      },
      attachProduct() {
        let params = {
          tag_ids: [this.tag.id],
          tagId: this.tag.id,
          product_ids: this.selectedProducts.map(i => i.id)
        }

        this.store.attachProduct(params).then(() => {
          this.store.sendMetrics({name: 'add_product_tag', params: this.$route.params, path: this.$route.fullPath})
          this.selectedProducts = []
          this.store.getTag(this.tagId)
          this.$refs.tagProductModal.close()
        })
      },
      attachDocumentType() {
        let params = {
          tag_ids: [this.tag.id],
          tagId: this.tag.id,
          document_type_ids: this.selectedDocumentTypes.map(i => i.id)
        }

        this.store.attachDocumentType(params).then(() => {
          this.store.sendMetrics({name: 'add_doc_type_tag', params: this.$route.params, path: this.$route.fullPath})
          this.selectedDocumentTypes = []
          this.store.getTag(this.tagId)
          this.$refs.tagDocumentTypeModal.close()
        })
      },
      attachContact() {
        let params = {
          tag_ids: [this.tag.id],
          tagId: this.tag.id,
          contact_ids: this.selectedContacts.map(i => i.id)
        }

        this.store.attachContact(params).then(() => {
          this.store.sendMetrics({name: 'add_contact_tag', params: this.$route.params, path: this.$route.fullPath})
          this.selectedContacts = []
          this.store.getTag(this.tagId)
          this.$refs.tagContactModal.close()
        })
      },
      contactsLabel({name, email}) {
        return `${name} - ${email || this.$t('folders_list.no_email')}`
      },
      routeMessageType(message){
        if (message.type === 'DocumentRequest') {
          return 'sent'
        }
        if (message.type === 'DocumentResponse') {
          return 'inbox'
        }
        if (message.type === 'SentEmail') {
          return 'automated-emails'
        }
        if (message.type === 'RecordMessage') {
          return 'record_message_show'
        }
        return null
      },
      sentTo(message){
        let list = []
        let currentOrg = this.currentOrg

        if(message.sent_to_contacts && message.sent_to_contacts !== undefined){
          message.sent_to_contacts.map( (item) => {
            if(item.id !== undefined)
                list.push(this.formatName(item.name, item.email))
          })
        }
        if(message.sent_to_users && message.sent_to_users !== undefined){
          message.sent_to_users.map( (item) => {
            if(item.id !== undefined)
                list.push(this.formatName(item.full_name, item.email))
          })
        }

        return list.join(', ')
      },
      formatName(name, email){
        if(email)
          return `${name} <${email}>`
        else
          return name
      },
      attachFolder() {
        let params = {
          tag_ids: [this.tag.id],
          tagId: this.tag.id,
          folder_ids: this.selectedFolders.map(i => i.id)
        }

        this.store.attachContact(params).then(() => {
          this.store.sendMetrics({name: 'add_folder_tag', params: this.$route.params, path: this.$route.fullPath})
          this.selectedFolders = []
          this.store.getTag(this.tagId)
          this.$refs.tagFolderModal.close()
        })
      },
      routeMessageType(message){
        if (message.type === 'DocumentRequest')
          return 'sent'
        if (message.type === 'DocumentResponse')
          return 'inbox'
        if (message.type === 'SentEmail')
          return 'automated-emails'

        return null
      },
      getFolders(params) {
        return this.listStore.getFolders(params)
      },
      getContacts(params) {
        return this.listStore.getContacts(params)
      },
      getProducts(params) {
        return this.listStore.getProducts(params)
      },
      getDocumentTypes(params) {
        return this.listStore.getDocumentTypes(params)
      },
    }
  }
</script>


<style lang='sass' scoped>
  @import '../styles/tags'
  .table tr td.data-img
    width: 40px
    img
      width: 40px
</style>
